export interface DefaultFormValues {
  error: string | undefined;
  success: string | undefined;
}

export function formValues<T extends object>(initial: T): T & DefaultFormValues {
  return { ...initial, error: undefined, success: undefined };
}